import CoordRemapper from './coordRemapper.js';

class CoordUnradializer extends CoordRemapper {
    constructor(params) {
        super();

        let { circle, rectangle } = params;

        {
            let { center: { x, y }, radius } = circle;
            this._circle = { radius, center: { x, y } };
        }

        {
            let { width, height } = rectangle;
            this._rectangle = { width, height };
        }
    }

    makeTransform() {
        let { width, height } = this._rectangle;
        let { radius, center: { x: cx, y: cy } } = this._circle;

        let { PI, cos, sin } = Math;

        let radiusOverWidth = radius/width;
        let piOverHalfHeight = 2*PI/height;

        return (x, y) => {
            let distance = radius-x*radiusOverWidth;
            let angle = y*piOverHalfHeight-PI;

            let dx = cos(angle)*distance;
            let dy = sin(angle)*distance;

            return [cx+dx, cy+dy];
        };
    }
}

export default CoordUnradializer;
